import React, { useEffect, useState } from "react";
import api from "../../../../../api";
import "./AddCallForward.css";

const AddVoicemailMessage = ({ workspace_id, popupClose }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [voicemailMessage, setVoicemailMessage] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    fetchVoicemailMessage();
  }, []);

  useEffect(() => {
    if (!status.message) return;
    const timer = setTimeout(() => setStatus({ type: "", message: "" }), 4000);
    return () => clearTimeout(timer);
  }, [status]);

  const fetchVoicemailMessage = async () => {
    setLoading(true);
    try {
      const res = await api.outbound.getVoicemailMessage({ workspace_id });
      if (res?.status && res.data?.message) {
        setVoicemailMessage(res.data.message);
      }
    } catch (error) {
      console.error("Fetch Voicemail Message Error:", error);
      setStatus({ type: "error", message: "Failed to load voicemail message." });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => setVoicemailMessage(e.target.value);

  const saveVoicemailMessage = async () => {
    // if (!voicemailMessage.trim()) {
    //   return setStatus({
    //     type: "error",
    //     message: "Voicemail message cannot be empty.",
    //   });
    // }

    setSaving(true);
    try {
      const res = await api.outbound.saveVoicemailMessage({
        workspace_id,
        message: voicemailMessage.trim(),
      });

      if (res?.status) {
        setStatus({ type: "success", message: "Voicemail message saved successfully." });
      } else {
        setStatus({ type: "error", message: "Failed to save voicemail message." });
      }
    } catch (err) {
      console.error("Save Voicemail Message Error:", err);
      setStatus({ type: "error", message: "Something went wrong. Try again." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {(loading || saving) && <div className="ui loading form"></div>}

      <div className="yr-chat-round-box yr-closebtn">
        {/* Close Button */}
        <button
          type="button"
          className="close linear-gradient"
          onClick={popupClose}
          aria-label="Close"
        >
          &#10006;
        </button>

        {/* Input */}
        <label>
          <strong>Voicemail Message</strong>
        </label>
         {/* Messages */}
        {status.message && (
          <div
            className={`ui message ${status.type === "success" ? "green" : "red"}`}
            style={{ marginTop: "10px", width: "fit-content" }}
          >
            {status.message}
          </div>
        )}
        <textarea
          className={`form-control ${status.type === "error" ? "input-error" : ""}`}
          rows="4"
          placeholder="Enter voicemail message here..."
          value={voicemailMessage}
          onChange={handleChange}
          disabled={saving}
        />
        {/* Actions */}
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-12 d-flex justify-content-end">
            <button
              type="reset"
              className="btn linear-gradient-cancel yr-cancelbtn mg-r"
              onClick={popupClose}
              disabled={saving}
            >
              <span>Close</span>
            </button>
            <button
              type="submit"
              disabled={saving}
              className="btn linear-gradient yr-submitbtn"
              onClick={saveVoicemailMessage}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVoicemailMessage;
